import { capitalCase } from "change-case";
import React from "react";
import { Text, View } from "react-native";

export function renderObjectValues(obj: any, keysToIgnore: string[], t: any) {
  if (!obj || typeof obj !== "object") {
    return null;
  }

  return Object.keys(obj).map((key) => {
    if (keysToIgnore.includes(key)) {
      return null;
    }

    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      return;
    }

    return (
      <View key={key} className="flex-row mt-1.5 w-full gap-1">
        <Text numberOfLines={1} ellipsizeMode="middle" className="text-lg">
          {capitalCase(key)}:{" "}
        </Text>
        <Text
          numberOfLines={1}
          ellipsizeMode="middle"
          className="text-lg font-light"
        >
          {Array.isArray(obj[key]) ? obj[key].join(", ") : obj[key]}
        </Text>
      </View>
    );
  });
}

export function renderInvestmentProfileObjectValues(
  obj: any,
  keysToIgnore: string[],
  t: any
) {
  if (!obj || typeof obj !== "object") {
    return null;
  }

  return Object.keys(obj).map((key) => {
    if (keysToIgnore.includes(key)) {
      return null;
    }

    if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
      return;
    }

    return (
      <View key={key} className="flex-row mt-1.5 gap-1">
        <Text numberOfLines={1} ellipsizeMode="middle" className="text-lg">
          {capitalCase(key)}:{" "}
        </Text>
        <Text
          numberOfLines={1}
          ellipsizeMode="middle"
          className="text-lg font-light"
        >
          {t(`enums:InvestmentProfile.${obj[key]}`)}
        </Text>
      </View>
    );
  });
}

export function renderIndividualCard(individual: any, index: number, t: any) {
  const keysToIgnore = ["id", "mailingAddress"];

  return (
    <View
      key={individual.id}
      className="border border-gray rounded-lg p-4 w-full lg:w-200 m-2 shadow"
    >
      <View className="flex-col gap-4 lg:gap-0 lg:flex-row">
        <View className="items-start w-full lg:w-1/2">
          <Text className="text-lg font-semibold">
            {t("management/customer:individuals.title")}
          </Text>
          {renderObjectValues(individual, keysToIgnore, t)}
        </View>
        <View className="items-start w-full lg:w-1/2">
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            className="text-lg font-semibold"
          >
            {t("management/customer:individuals.mailingaddress.title")}
          </Text>
          {renderObjectValues(individual.mailingAddress, [], t)}
        </View>
      </View>
    </View>
  );
}
